import { configEnv } from '@libraries/config';

export const loginSliderData: ILoginSlider[] = [
  {
    id: 1,
    bg: `${configEnv.assetUrl}/img/login/slide-1.webp`,
    title: 'Selamat Datang di Carte, mitra logistik anda',
    description:
      'Untuk melacak inventaris Anda dan memantau pesanan Anda, Mulailah dengan menyiapkan akun anda',
    footer: 'Copyright © 2023  Carte, Inc. All rights reserved.',
  },
  {
    id: 2,
    bg: `${configEnv.assetUrl}/img/login/slide-2.webp`,
    title: 'Pantau stok dan fulfillment Anda melalui Fulfillment Portal',
    description:
      'Dapatkan pembaruan dan laporan waktu nyata melalui antarmuka yang mudah digunakan kapan pun Anda membutuhkannya.',
    footer: 'Copyright © 2023  Carte, Inc. All rights reserved.',
  },
];

export interface ILoginSlider {
  id: number;
  bg: string;
  title: string;
  description: string;
  footer: string;
}
